import _ from 'lodash';

export const CORE_INDICATORS = [
  {
    label: '流量指标',
    data: [
      {
        label: '搜索UV',
        value: 'search_uv',
        tip: '进入搜索结果页的用户',
      },
      {
        label: '搜索次数',
        value: 'search_qtty',
        tip: '搜索结果页中page=1的曝光PV',
      },
      {
        label: '搜索sku件次',
        value: 'search_item_piece',
        tip: 'sku在搜索结果页中曝光一次则加1',
      },
      {
        label: '搜索PV',
        value: 'search_pv',
        tip: '搜索结果页中每曝光1页增加1',
      },
      {
        label: '搜索件次CTR',
        value: 'fo_ctr',
        tip: '点击PV/搜索sku件次',
      },
      {
        label: '点击UV',
        value: 'search_click_uv',
        tip: '点击PV按用户去重',
      },
      {
        label: '点击PV',
        value: 'search_click_pv',
        tip: '搜索结果页坑位中每点击一次则加1',
      },
      {
        label: 'UCTR',
        value: 'fo_uctr',
        tip: '点击PV/搜索UV',
      },
    ],
  },
  {
    label: '出库指标',
    data: [
      {
        label: '出库金额',
        value: 'search_ord_out_ord_amt',
        tip: '出库订单行优惠后金额汇总',
      },
      {
        label: '订单行（出库订单）',
        value: 'search_ord_out_line_ord_qtty',
        tip: '精准路径树、L2_new去作弊，出库口径，父单号+sku去重',
      },
      {
        label: '订单量（出库订单）',
        value: 'search_ord_out_father_ord_qtty',
        tip: '出库订单对子单号进行去重计算',
      },
      {
        label: '出库数量',
        value: 'search_ord_out_ord_item_piece',
        tip: '出库订单行sku件数',
      },
      {
        label: '出库人数',
        value: 'search_ord_out_ord_user_qtty',
        tip: '出库订单行下单用户数',
      },
      {
        label: '客单价（出库订单）',
        value: 'fo_pct',
        tip: '出库金额/出库订单行',
      },
      {
        label: '件单价（出库订单）',
        value: 'fo_search_qtty_pct',
        tip: '出库金额/出库数量',
      },
      {
        label: '搜索CVR（出库订单）',
        value: 'fo_search_cvr',
        tip: '出库订单行/点击PV',
      },
      {
        label: 'UCVR（出库订单）',
        value: 'fo_search_ucvr_out',
        tip: '出库金额/搜索UV',
      },
      {
        label: 'UV价值（出库订单）',
        value: 'fo_uv_value_out',
        tip: '出库订单行/点击PV',
      },
      {
        label: '商品曝光RPM（出库订单）',
        value: 'fo_search_rpm_out',
        tip: '出库金额/搜索PV*1000',
      },
    ],
  },
  {
    label: '交易指标',
    data: [
      {
        label: '成交金额',
        value: 'search_ord_deal_ord_amt',
        tip: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
      },
      {
        label: '订单行（成交订单）',
        value: 'search_ord_deal_line_ord_qtty',
        tip: '精准路径树、L2_new去作弊，成交口径，父单号+sku去重',
      },
      {
        label: '订单量（成交订单)',
        value: 'search_ord_deal_father_ord_qtty',
        tip: '成交订单对子单号进行去重计算',
      },
      {
        label: '成交数量',
        value: 'search_ord_deal_ord_item_piece',
        tip: '成交订单行sku件数',
      },
      {
        label: '成交人数',
        value: 'search_ord_deal_ord_user_qtty',
        tip: '成交订单行下单用户数',
      },
      {
        label: '客单价（成交订单）',
        value: 'fo_search_pct_cj',
        tip: '成交金额/成交订单行',
      },
      {
        label: '件单价（成交订单）',
        value: 'fo_search_qtty_pct_cj',
        tip: '成交金额/成交数量',
      },
      {
        label: '搜索CVR（成交订单）',
        value: 'fo_search_cvr_cj',
        tip: '成交订单行/点击PV',
      },
      {
        label: 'UCVR（成交订单）',
        value: 'fo_search_ucvr_cj',
        tip: '成交订单行/搜索UV',
      },
      {
        label: 'UV价值（成交订单）',
        value: 'fo_search_uv_value_cj',
        tip: '成交金额/搜索UV',
      },
      {
        label: '商品曝光RPM（成交订单）',
        value: 'fo_search_rpm_cj',
        tip: '成交金额/搜索PV*1000',
      },
    ],
  },
  {
    label: '体验指标',
    data: [
      {
        label: '平均点击位置',
        value: 'fo_search_avg_click_pos',
        tip: '对所有搜索结果页点击数据中的位置累加求平均',
      },
      {
        label: '平均下单位置',
        value: 'fo_search_avg_order_pos',
        tip: '对所有搜索订单中的位置累计求平均',
      },
    ],
  },
  {
    label: '商品指标',
    data: [
      {
        label: '曝光商品数',
        value: 'search_expose_item_qtty',
        tip: '搜索sku件次按sku去重',
      },
      {
        label: '点击商品数',
        value: 'search_click_item_qtty',
        tip: '点击PV按sku去重',
      },
      {
        label: '成交商品数',
        value: 'search_ord_deal_ord_item_qtty',
        tip: '成交数量按sku去重',
      },
      {
        label: '出库商品数',
        value: 'search_ord_out_ord_item_qtty',
        tip: '出库数量按sku去重',
      },
    ],
  },
];

export const TREND_INDICATORS = {
  point: '日期',
  search_click_pv: '点击PV',
  search_click_uv: '点击UV',
  search_item_piece: '搜索sku件次',
  search_pv: '搜索PV',
  search_uv: '搜索UV',
  search_qtty: '搜索次数',
  fo_ctr: '搜索件次CTR',
  fo_uctr: 'UCTR',
  search_ord_out_ord_amt: '出库金额',
  fo_uv_value_out: 'UV价值（出库订单）',
  search_ord_deal_ord_amt: '成交金额',
  search_ord_deal_ord_user_qtty: '成交人数',
  search_ord_deal_father_ord_qtty: '订单量（成交订单）',
  search_ord_out_father_ord_qtty: '订单量（出库订单）',
  search_ord_out_line_ord_qtty: '订单行（出库订单）',
  search_ord_out_ord_user_qtty: '出库人数',
  fo_pct: '客单价（出库订单）',
  fo_search_cvr: '搜索CVR（出库订单）',
  fo_search_ucvr_out: 'UCVR（出库订单）',
  fo_search_rpm_out: '商品曝光RPM（出库订单）',
  search_ord_deal_line_ord_qtty: '订单行（成交订单）',
  fo_search_pct_cj: '客单价（成交订单）',
  fo_search_cvr_cj: '搜索CVR（成交订单）',
  fo_search_ucvr_cj: 'UCVR（成交订单）',
  fo_search_uv_value_cj: 'UV价值（成交订单）',
  fo_search_rpm_cj: '商品曝光RPM（成交订单）',
  fo_search_avg_click_pos: '平均点击位置',
  fo_search_avg_order_pos: '平均下单位置',
  search_click_item_qtty: '点击商品数',
  search_ord_out_ord_item_piece: '出库数量',
  fo_search_qtty_pct: '件单价（出库订单）',
  search_ord_deal_ord_item_piece: '成交数量',
  fo_search_qtty_pct_cj: '件单价（成交订单）',
  search_ord_deal_ord_item_qtty: '成交商品数',
  search_ord_out_ord_item_qtty: '出库商品数',
  search_expose_item_qtty: '曝光商品数',
};

export const TOTAL_INDICATORS = [
  {
    name: '搜索UV',
    value: 'search_uv',
    tip: '进入搜索结果页的用户',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索次数',
    value: 'search_qtty',
    tip: '搜索结果页中page=1的曝光PV',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索sku件次',
    value: 'search_item_piece',
    tip: 'sku在搜索结果页中曝光一次则加1',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索PV',
    value: 'search_pv',
    tip: '搜索结果页中每曝光1页增加1',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索件次CTR',
    value: 'fo_ctr',
    tip: '点击PV/搜索sku件次',
    number: 0,
    ratio: 0,
  },
  {
    name: '点击UV',
    value: 'search_click_uv',
    tip: '点击PV按用户去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '点击PV',
    value: 'search_click_pv',
    tip: '搜索结果页坑位中每点击一次则加1',
    number: 0,
    ratio: 0,
  },
  {
    name: 'UCTR',
    value: 'fo_uctr',
    tip: '点击PV/搜索UV',
    number: 0,
    ratio: 0,
  },
  {
    name: '出库金额',
    value: 'search_ord_out_ord_amt',
    tip: '出库订单行优惠后金额汇总',
    number: 0,
    ratio: 0,
  },
  {
    name: '订单行（出库订单）',
    value: 'search_ord_out_line_ord_qtty',
    tip: '精准路径树、L2_new去作弊，出库口径，父单号+sku去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '订单量（出库订单）',
    value: 'search_ord_out_father_ord_qtty',
    tip: '出库订单对子单号进行去重计算',
    number: 0,
    ratio: 0,
  },
  {
    name: '出库数量',
    value: 'search_ord_out_ord_item_piece',
    tip: '出库订单行sku件数',
    number: 0,
    ratio: 0,
  },
  {
    name: '出库人数',
    value: 'search_ord_out_ord_user_qtty',
    tip: '出库订单行下单用户数',
    number: 0,
    ratio: 0,
  },
  {
    name: '客单价（出库订单）',
    value: 'fo_pct',
    tip: '出库金额/出库订单行',
    number: 0,
    ratio: 0,
  },
  {
    name: '件单价（出库订单）',
    value: 'fo_search_qtty_pct',
    tip: '出库金额/出库数量',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索CVR（出库订单）',
    value: 'fo_search_cvr',
    tip: '出库订单行/点击PV',
    number: 0,
    ratio: 0,
  },
  {
    name: 'UCVR（出库订单）',
    value: 'fo_search_ucvr_out',
    tip: '出库金额/搜索UV',
    number: 0,
    ratio: 0,
  },
  {
    name: 'UV价值（出库订单）',
    value: 'fo_uv_value_out',
    tip: '出库订单行/点击PV',
    number: 0,
    ratio: 0,
  },
  {
    name: '商品曝光RPM（出库订单）',
    value: 'fo_search_rpm_out',
    tip: '出库金额/搜索PV*1000',
    number: 0,
    ratio: 0,
  },
  {
    name: '成交金额',
    value: 'search_ord_deal_ord_amt',
    tip: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
    number: 0,
    ratio: 0,
  },
  {
    name: '订单行（成交订单）',
    value: 'search_ord_deal_line_ord_qtty',
    tip: '精准路径树、L2_new去作弊，成交口径，父单号+sku去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '订单量（成交订单)',
    value: 'search_ord_deal_father_ord_qtty',
    tip: '成交订单对子单号进行去重计算',
    number: 0,
    ratio: 0,
  },
  {
    name: '成交数量',
    value: 'search_ord_deal_ord_item_piece',
    tip: '成交订单行sku件数',
    number: 0,
    ratio: 0,
  },
  {
    name: '成交人数',
    value: 'search_ord_deal_ord_user_qtty',
    tip: '成交订单行下单用户数',
    number: 0,
    ratio: 0,
  },
  {
    name: '客单价（成交订单）',
    value: 'fo_search_pct_cj',
    tip: '成交金额/成交订单行',
    number: 0,
    ratio: 0,
  },
  {
    name: '件单价（成交订单）',
    value: 'fo_search_qtty_pct_cj',
    tip: '成交金额/成交数量',
    number: 0,
    ratio: 0,
  },
  {
    name: '搜索CVR（成交订单）',
    value: 'fo_search_cvr_cj',
    tip: '成交订单行/点击PV',
    number: 0,
    ratio: 0,
  },
  {
    name: 'UCVR（成交订单）',
    value: 'fo_search_ucvr_cj',
    tip: '成交订单行/搜索UV',
    number: 0,
    ratio: 0,
  },
  {
    name: 'UV价值（成交订单）',
    value: 'fo_search_uv_value_cj',
    tip: '成交金额/搜索UV',
    number: 0,
    ratio: 0,
  },
  {
    name: '商品曝光RPM（成交订单）',
    value: 'fo_search_rpm_cj',
    tip: '成交金额/搜索PV*1000',
    number: 0,
    ratio: 0,
  },
  {
    name: '平均点击位置',
    value: 'fo_search_avg_click_pos',
    tip: '对所有搜索结果页点击数据中的位置累加求平均',
    number: 0,
    ratio: 0,
  },
  {
    name: '平均下单位置',
    value: 'fo_search_avg_order_pos',
    tip: '对所有搜索订单中的位置累计求平均',
    number: 0,
    ratio: 0,
  },
  {
    name: '曝光商品数',
    value: 'search_expose_item_qtty',
    tip: '搜索sku件次按sku去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '点击商品数',
    value: 'search_click_item_qtty',
    tip: '点击PV按sku去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '成交商品数',
    value: 'search_ord_deal_ord_item_qtty',
    tip: '成交数量按sku去重',
    number: 0,
    ratio: 0,
  },
  {
    name: '出库商品数',
    value: 'search_ord_out_ord_item_qtty',
    tip: '出库数量按sku去重',
    number: 0,
    ratio: 0,
  },
];
//千分位，1位小数  如5,839.3
export const THOUSAND_ONE = ['search_ord_out_ord_amt', 'search_ord_deal_ord_amt'];
//指标保留百分数，保留2位，如2.38%
export const PERCENT_TOW = [
  'fo_ctr',
  'fo_uctr',
  'fo_search_cvr',
  'fo_search_ucvr_out',
  'fo_search_cvr_cj',
  'fo_search_ucvr_cj',
];
//指标保留1位小数，如35.4
export const FLOAT_ONE = [
  'fo_pct',
  'fo_search_qtty_pct',
  'fo_uv_value_out',
  'fo_search_rpm_out',
  'fo_search_pct_cj',
  'fo_search_qtty_pct_cj',
  'fo_search_uv_value_cj',
  'fo_search_rpm_cj',
];
//指标保留2位小数，如4.23
export const FLOAT_TOW = ['fo_search_avg_click_pos', 'fo_search_avg_order_pos'];

const summaryList:any = {
  'search_uv': {
    value: 'search_uv',
    des: '进入搜索结果页的用户',
    name: '搜索UV',
    type: 1,
  },
  'search_qtty': {
    value: 'search_qtty',
    des: '进入搜索结果页的用户',
    name: '搜索结果页中page=1的曝光PV',
    type: 6,
  },
  'search_item_piece': {
    name: '搜索sku件次',
    value: 'search_item_piece',
    des: 'sku在搜索结果页中曝光一次则加1',
    type: 1,
  },
  'search_pv': {
    name: '搜索PV',
    value: 'search_pv',
    des: '搜索结果页中每曝光1页增加1',
    type: 1,
  },
  'fo_ctr': {
    name: '搜索件次CTR',
    value: 'fo_ctr',
    des: '点击PV/搜索sku件次',
    type: 2,
  },
  'search_click_uv': {
    name: '点击UV',
    value: 'search_click_uv',
    des: '点击PV按用户去重',
    type: 1,
  },
  'search_click_pv': {
    name: '点击PV',
    value: 'search_click_pv',
    des: '搜索结果页坑位中每点击一次则加1',
    type: 1,
  },
  'fo_uctr': {
    name: 'UCTR',
    value: 'fo_uctr',
    des: '点击PV/搜索UV',
    type: 2,
  },
  'search_ord_out_ord_amt': {
    name: '出库金额',
    value: 'search_ord_out_ord_amt',
    des: '出库订单行优惠后金额汇总',
    type: 6,
  },
  'search_ord_out_line_ord_qtty': {
    name: '订单行（出库订单）',
    value: 'search_ord_out_line_ord_qtty',
    des: '精准路径树、L2_new去作弊，出库口径，父单号+sku去重',
    type: 1,
  },
  'search_ord_out_father_ord_qtty': {
    name: '订单量（出库订单）',
    value: 'search_ord_out_father_ord_qtty',
    des: '出库订单对子单号进行去重计算',
    type: 1,
  },
  'search_ord_out_ord_item_piece': {
    name: '出库数量',
    value: 'search_ord_out_ord_item_piece',
    des: '出库订单行sku件数',
    type: 1,
  },
  'search_ord_out_ord_user_qtty': {
    name: '出库人数',
    value: 'search_ord_out_ord_user_qtty',
    des: '出库订单行下单用户数',
    type: 1,
  },
  'fo_pct': {
    name: '客单价（出库订单）',
    value: 'fo_pct',
    des: '出库金额/出库订单行',
    type: 6,
  },
  'fo_search_qtty_pct': {
    name: '件单价（出库订单）',
    value: 'fo_search_qtty_pct',
    des: '出库金额/出库数量',
    type: 6,
  },
  'fo_search_cvr': {
    name: '搜索CVR（出库订单）',
    value: 'fo_search_cvr',
    des: '出库订单行/点击PV',
    type: 2,
  },
  'fo_search_ucvr_out': {
    name: 'UCVR（出库订单）',
    value: 'fo_search_ucvr_out',
    des: '出库金额/搜索UV',
    type: 2,
  },
  'fo_uv_value_out': {
    name: 'UV价值（出库订单）',
    value: 'fo_uv_value_out',
    des: '出库订单行/点击PV',
    type: 2,
  },
  'fo_search_rpm_out': {
    name: '商品曝光RPM（出库订单）',
    value: 'fo_search_rpm_out',
    des: '出库金额/搜索PV*1000',
    type: 2,
  },
  'search_ord_deal_ord_amt': {
    name: '成交金额',
    value: 'search_ord_deal_ord_amt',
    des: '在线以订单支付时间统计，货到以下单时间统计，统计周期内，成交订单包含商品总金额。优惠后金额= 优惠前金额-（单品促销、满减、套装促销、团购促销、plus会员95折促销、京享礼金）促销优惠金额 – 所有优惠券金额 – 膨胀金优惠金额 – 京享礼金 + 出口退税金额 + 全球购税费 + 运费 + 服务费。',
    type: 6,
  },
  'search_ord_deal_line_ord_qtty': {
    name: '订单行（成交订单）',
    value: 'search_ord_deal_line_ord_qtty',
    des: '精准路径树、L2_new去作弊，成交口径，父单号+sku去重',
    type: 1,
  },
  'search_ord_deal_father_ord_qtty': {
    name: '订单量（成交订单)',
    value: 'search_ord_deal_father_ord_qtty',
    des: '成交订单对子单号进行去重计算',
    type: 1,
  },
  'search_ord_deal_ord_item_piece': {
    name: '成交数量',
    value: 'search_ord_deal_ord_item_piece',
    des: '成交订单行sku件数',
    type: 1,
  },
  'search_ord_deal_ord_user_qtty': {
    name: '成交人数',
    value: 'search_ord_deal_ord_user_qtty',
    des: '成交订单行下单用户数',
    type: 1,
  },
  'fo_search_pct_cj': {
    name: '客单价（成交订单）',
    value: 'fo_search_pct_cj',
    des: '成交金额/成交订单行',
    type: 6,
  },
  'fo_search_qtty_pct_cj': {
    name: '件单价（成交订单）',
    value: 'fo_search_qtty_pct_cj',
    des: '成交金额/成交数量',
    type: 6,
  },
  'fo_search_cvr_cj': {
    name: '搜索CVR（成交订单）',
    value: 'fo_search_cvr_cj',
    des: '成交订单行/点击PV',
    type: 2,
  },
  'fo_search_ucvr_cj': {
    name: 'UCVR（成交订单）',
    value: 'fo_search_ucvr_cj',
    des: '成交订单行/搜索UV',
    type: 2,
  },
  'fo_search_uv_value_cj': {
    name: 'UV价值（成交订单）',
    value: 'fo_search_uv_value_cj',
    des: '成交金额/搜索UV',
    type: 2,
  },
  'fo_search_rpm_cj': {
    name: '商品曝光RPM（成交订单）',
    value: 'fo_search_rpm_cj',
    des: '成交金额/搜索PV*1000',
    type: 2,
  },
  'fo_search_avg_click_pos': {
    name: '平均点击位置',
    value: 'fo_search_avg_click_pos',
    des: '对所有搜索结果页点击数据中的位置累加求平均',
    type: 1,
  },
  'fo_search_avg_order_pos': {
    name: '平均下单位置',
    value: 'fo_search_avg_order_pos',
    des: '对所有搜索订单中的位置累计求平均',
    type: 1,
  },
  'search_expose_item_qtty': {
    name: '曝光商品数',
    value: 'search_expose_item_qtty',
    des: '搜索sku件次按sku去重',
    type: 1,
  },
  'search_click_item_qtty': {
    name: '点击商品数',
    value: 'search_click_item_qtty',
    des: '点击PV按sku去重',
    type: 1,
  },
  'search_ord_deal_ord_item_qtty': {
    name: '成交商品数',
    value: 'search_ord_deal_ord_item_qtty',
    des: '成交数量按sku去重',
    type: 1,
  },
  'search_ord_out_ord_item_qtty': {
    name: '出库商品数',
    value: 'search_ord_out_ord_item_qtty',
    des: '出库数量按sku去重',
    type: 1,
  },
}
export const indexIdList = [
  'search_uv',
  'search_qtty',
  'search_item_piece',
  'search_pv',
  'fo_ctr',
  'search_click_uv',
  'search_click_pv',
  'fo_uctr',
  'search_ord_out_ord_amt',
  'search_ord_out_line_ord_qtty',
  'search_ord_out_father_ord_qtty',
  'search_ord_out_ord_item_piece',
  'search_ord_out_ord_user_qtty',
  'fo_pct',
  'fo_search_qtty_pct',
  'fo_search_cvr',
  'fo_search_ucvr_out',
  'fo_uv_value_out',
  'fo_search_rpm_out',
  'search_ord_deal_ord_amt',
  'search_ord_deal_line_ord_qtty',
  'search_ord_deal_father_ord_qtty',
  'search_ord_deal_ord_item_piece',
  'search_ord_deal_ord_user_qtty',
  'fo_search_pct_cj',
  'fo_search_qtty_pct_cj',
  'fo_search_cvr_cj',
  'fo_search_ucvr_cj',
  'fo_search_uv_value_cj',
  'fo_search_rpm_cj',
  'fo_search_avg_click_pos',
  'fo_search_avg_order_pos',
  'search_expose_item_qtty',
  'search_click_item_qtty',
  'search_ord_deal_ord_item_qtty',
  'search_ord_out_ord_item_qtty'
];

export function getSummaryData(data:any, selectedIndex:any){
  if(_.isEmpty(data)) return []
  const list = data?.[0];
  const result = selectedIndex.map((index:any)=>{
    const norms = [{
      code: "ratio",
      name: "较对比日",
      type: 2,
      value:list[`${index}_ratio`],
    }]
    if(list.hasOwnProperty(`${index}_app_ratio`)){
      norms.push({
        code: "app_ratio",
        name: "APP占比",
        type: 2,
        value:list[`${index}_app_ratio`],
      })
    }
    const obj = {
      ...summaryList[index],
      data: list[index],
      norms
    }
    return obj
  })
  return result
}
